import styled from 'styled-components';
import dotImage from 'components/icons/dots.svg';

export const HelpContainer = styled.div`
  & canvas {
    background: url(${dotImage});
  }
`;
